/**
 * TopicTodoList - Collapsible learning goals (starts collapsed)
 */

import { useState } from "react";
import { Circle, Target, ChevronDown, ChevronRight } from "lucide-react";

interface TodoItem {
    id: string;
    text: string;
    completed: boolean;
    order: number;
}

interface TopicTodoListProps {
    todos: TodoItem[] | undefined | null;
}

export const TopicTodoList = ({ todos }: TopicTodoListProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!todos || todos.length === 0) return null;

    // Sort by order
    const sortedTodos = [...todos].sort((a, b) => a.order - b.order);

    return (
        <div className="bg-white border border-slate-200 shadow-sm rounded-xl overflow-hidden">
            {/* Collapsible Header */}
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full flex items-center justify-between p-4 hover:bg-slate-50 transition-colors"
            >
                <div className="flex items-center gap-2">
                    <Target className="w-4 h-4 text-slate-500" />
                    <h3 className="text-sm font-medium text-slate-700">
                        Learning Goals
                    </h3>
                    <span className="text-xs text-slate-400">
                        ({sortedTodos.length})
                    </span>
                </div>
                {isExpanded ? (
                    <ChevronDown className="w-4 h-4 text-slate-400" />
                ) : (
                    <ChevronRight className="w-4 h-4 text-slate-400" />
                )}
            </button>

            {/* Collapsible Content */}
            {isExpanded && (
                <ul className="px-4 pb-4 space-y-2 border-t border-slate-100 pt-3">
                    {sortedTodos.map((todo) => (
                        <li
                            key={todo.id}
                            className="flex items-start gap-2.5"
                        >
                            <Circle className="w-4 h-4 text-slate-300 flex-shrink-0 mt-0.5" />
                            <span className="text-sm text-slate-700">
                                {todo.text}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TopicTodoList;
